import { type ReactElement, useState } from "react"

import { useTranslation } from "react-i18next"

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { Typography } from "@synapse-analytics/synapse-ui"

import { SUGGESTIONS } from "../Fixtures"
import type { SuggestionsProps } from "../interfaces"

import styles from "./Suggestions.module.scss"

export function Suggestions(props: Readonly<SuggestionsProps>): ReactElement {
  const { t } = useTranslation("KonanAssistant")
  const { onSelect } = props

  const pageSize = 3
  const [page, setPage] = useState<number>(0)

  return (
    <div className={styles.suggestionsRoot}>
      <Typography variant="p">{t("suggestions.title")}</Typography>

      <div className={styles.suggestionsWrapper}>
        {SUGGESTIONS.length > pageSize && (
          <button className={styles.suggestionButton} onClick={() => setPage((prev) => prev - 1)} disabled={page === 0}>
            <ChevronLeftIcon className={styles.icon} />
          </button>
        )}

        <div className={styles.suggestions}>
          {SUGGESTIONS.slice(page * pageSize, page * pageSize + pageSize).map((suggestion, index) => (
            <div className={styles.suggestion} key={index} onClick={() => onSelect(suggestion)}>
              <Typography variant="label-regular">{suggestion}</Typography>
            </div>
          ))}
        </div>

        {SUGGESTIONS.length > pageSize && (
          <button
            className={styles.suggestionButton}
            onClick={() => setPage((prev) => prev + 1)}
            disabled={page * pageSize + pageSize >= SUGGESTIONS.length}
          >
            <KeyboardArrowRightIcon className={styles.icon} />
          </button>
        )}
      </div>
    </div>
  )
}
